import {v4 as uuidv4} from 'uuid';
import axios from "axios";
import {safaricomConfig} from "@/config";

const SAFARICOM_IDENTITY_URL = `https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn`

// const penroseSafaricomHost = `http://localhost:4000`;
const penroseSafaricomHost = `https://api-safaricom.penrosekenya.com`;
const headers = {Authorization: `Basic ${safaricomConfig.authHeader}`};

export default class SafaricomService {
    static async getSafaricomUser(msisdn, productId) {
        return await axios.post(`${penroseSafaricomHost}/get-user`, {
            msisdn: Number(msisdn),
            productId: productId,
        }, {headers})
    }

    static async manualUpsertUser(user) {
        return await axios.post(`${penroseSafaricomHost}/manual-upsert-user`, {
            subscriptionStatus: user.subscriptionStatus,
            msisdn: user.msisdn,
            statusId: user.statusId,
            serviceId: user.serviceId,
            channel: user.channel,
            campaignId: user.campaignId,
            clickId: user.clickId,
            googleClickId: user.googleClickId
        }, {headers})
    }

    static async queueUserSubscription(msisdn, serviceId, productId, campaignId, channel = 'Web', clickId, publisherId, subpublisherId, gclid) {
        return await axios.post(`${penroseSafaricomHost}/queue-user-subscription`, {
            msisdn,
            serviceId,
            productId,
            campaignId,
            channel,
            clickId,
            publisherId,
            subpublisherId,
            gclid
        }, {headers})
    }

    static async getToken() {
        const response = await axios.get(`${penroseSafaricomHost}/get-token`, {headers});
        return response.data;
    }

    static async getSourceIP() {
        const response = await axios.get('https://api.ipify.org?format=json');
        return response?.data?.ip;
    }

    static async getCGURL(offerCode, msisdn, userAgent, sourceIP, requestId, redirectUrl) {
        const response = await axios.post(`${penroseSafaricomHost}/mfilter/get-cg`, {
            offerCode, msisdn, userAgent, sourceIP, requestId, redirectUrl
        }, {headers});
        return response.data;
    }

    // options.silent: suppress the user-facing alert() on lookup failure — used for passive,
    // best-effort lookups (e.g. the thank-you page) where a popup would interrupt the user.
    static async getMSISDN(decryptedMsisdn, {silent = false} = {}) {
        try {
            const token = await SafaricomService.getToken();
            console.log(`Auth Token: ${token}`);
            const response = await fetch(SAFARICOM_IDENTITY_URL, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'X-Source-System': 'he-partner',
                    'x-messageid': uuidv4(),
                    'X-App': 'he-partner'
                },
            });
            const data = await response.json();

            if (!response.ok) {
                const customerMessage = data?.header?.customerMessage || 'MSISDN Not Found';
                if (!silent) alert(`${customerMessage}`);
                if (decryptedMsisdn) return {msisdn: decryptedMsisdn};
                return {error: true, customerMessage};
            }

            if (data.ServiceResponse && data?.ServiceResponse?.ResponseBody?.Response.Msisdn !== '') {
                return {msisdn: data.ServiceResponse.ResponseBody.Response.Msisdn};
            }
            if (decryptedMsisdn) return {msisdn: decryptedMsisdn};
            return {error: true, customerMessage: data?.header?.customerMessage || 'MSISDN Not Found'};
        } catch (error) {
            console.error('getMSISDN error:', error);
            if (decryptedMsisdn) return {msisdn: decryptedMsisdn};
            return {error: true, customerMessage: 'An error occurred retrieving MSISDN'};
        }
    }
}
